module.exports = __webpack_public_path__ + "assets/e9307ade6d59a956596b30ac3a5c3544.png";